import { Alert, Button, ButtonSection, useSearchParam } from '@capsicum/common-web';
import { AlertIcon } from '@capsicum/common-web/icons';
import { useNCWConfirmTransfer } from '@capsicum/features/nc-wallet/web';
import styled, { useTheme } from 'styled-components';

import {
	NCWConfirmTransferAddressCard,
	NCWConfirmTransferAmountCard,
	NCWConfirmTransferFeeCard,
	NCWInsufficientChzAlert
} from '../../../ui';

export type NCWConfirmTransferProps = {};

const NCWConfirmTransferComponent = () => {
	const recipientId = useSearchParam('recipientId');
	const { spacings } = useTheme();

	const {
		addressCardData,
		handleClickConfirm,
		intlTexts,
		isFundInsufficient,
		isTransferEnabled,
		isTransferPending,
		transferAmountCardData,
		transferFeeCardData
	} = useNCWConfirmTransfer({
		recipientId
	});

	return (
		<S.Wrapper>
			<S.Container>
				<S.Title>{intlTexts.title}</S.Title>
				{transferAmountCardData && <NCWConfirmTransferAmountCard {...transferAmountCardData} />}
				{transferFeeCardData && <NCWConfirmTransferFeeCard {...transferFeeCardData} />}
				{isFundInsufficient && <NCWInsufficientChzAlert style={{ marginBottom: parseInt(spacings.xsmall) }} />}
				<NCWConfirmTransferAddressCard {...addressCardData} />

				<S.AlertMessage
					closable={false}
					icon={AlertIcon}
					subTitle={intlTexts.alertMessage}
					testID="withdraw-confirmation-alert"
					type="important"
				/>

				<ButtonSection>
					<Button
						disabled={addressCardData.isLoading || !isTransferEnabled}
						isLoading={addressCardData.isLoading || isTransferPending}
						testID="withdraw-confirmation-submitButton"
						text={intlTexts.continueButtonLabel}
						onClick={handleClickConfirm}
					/>
				</ButtonSection>
			</S.Container>
		</S.Wrapper>
	);
};

export const NCWConfirmTransfer = NCWConfirmTransferComponent;

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		width: 100%;
	`;

	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.xxlarge};
		width: 100%;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding: ${({ theme }) =>
				`${theme.spacings.large} ${theme.spacings.small} ${theme.spacings.small} ${theme.spacings.small}`};
		}
	`;
	export const Title = styled.p`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.headings.title5};
		margin: 0 0 ${({ theme }) => theme.spacings.xsmall};
	`;

	export const AlertMessage = styled(Alert)`
		margin: ${({ theme }) => `${theme.spacings.xxlarge} 0`};
	`;
}
